var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M36 18.11C36 8.10812 27.9411 0 18 0C8.05887 0 0 8.10812 0 18.11C0 27.1491 6.5823 34.6414 15.1875 36V23.3449H10.6172V18.11H15.1875V14.1201C15.1875 9.58132 17.8748 7.07422 21.9864 7.07422C23.9551 7.07422 26.0156 7.42793 26.0156 7.42793V11.8847H23.7459C21.51 11.8847 20.8125 13.2808 20.8125 14.7144V18.11H25.8047L25.0066 23.3449H20.8125V36C29.4177 34.6414 36 27.1491 36 18.11Z","fill":"#DBD9D6"}));
}

Facebook.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
